import { render, staticRenderFns } from "./BoxWithAction.vue?vue&type=template&id=22349c66&scoped=true"
import script from "./BoxWithAction.vue?vue&type=script&lang=js"
export * from "./BoxWithAction.vue?vue&type=script&lang=js"
import style0 from "./BoxWithAction.vue?vue&type=style&index=0&id=22349c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22349c66",
  null
  
)

export default component.exports